import {
  useCallback,
  useMemo,
} from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import { fetchAPI } from '../../../api/request';
import { API as deliveryNote } from '../../../module/deliveryNote/api';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import _ from 'lodash';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ModalSendOfBase from './ModalSendOfBase.component';

const ModalSendOfEmail = ({
  id,
  children,
  conf,
  disabled,
  data,
  logbook,
  setSuccessUpdate = () => {},
  code,
  button,
  onSubmitAction: externalOnSubmitAction,
  withForm = true,
  submitLabel = 'Confirm',
  loadingLabel = 'Sending...',
  successMessage = 'Success: Email sent!',
  defaultValuesOverride,
  showMailSendedIndicator = true,
}) => {
  const { jwt, user } = useSelector((state) => state.login);
  const mailSended = useMemo(
    () => _.get(logbook, 'attributes.mail_sended'),
    [logbook]
  );

  const onSubmitAction = useCallback(
    (values = {}) => {
      if (externalOnSubmitAction) {
        return externalOnSubmitAction(values);
      }

      const dataForm = {
        ...values,
        ...code,
        id_logbook: id,
        sendMail: true,
        mail_sended: true,
      };

      return fetchAPI(deliveryNote.supplierOrder, {}, '', { data: dataForm }, jwt);
    },
    [externalOnSubmitAction, code, id, jwt]
  );

  const defaultButton = useMemo(() => {
    if (button) {
      return button;
    }

    return (
      <Stack direction={'row'} alignItems={'center'}>
        <Tooltip title='Send OF'>
          <IconButton disabled={disabled} color='primary' size='large'>
            <ForwardToInboxIcon />
          </IconButton>
        </Tooltip>
        {showMailSendedIndicator && mailSended && (
          <Tooltip title='Email sent at least once'>
            <PriorityHighIcon sx={{ color: 'red' }} />
          </Tooltip>
        )}
      </Stack>
    );
  }, [button, disabled, showMailSendedIndicator, mailSended]);

  const defaultValues = useMemo(
    () => ({
      name: `${_.get(data, 'attributes.mexal_code')} - ${_.get(data, 'attributes.company_name')}`,
      email: _.get(data, 'attributes.email') || '',
      note: '',
      is_yacht_visible: true,
      id_user_cc: user?.id,
      ...defaultValuesOverride,
    }),
    [data, user, defaultValuesOverride]
  );

  const onCloseSuccess = useCallback(() => {
    setSuccessUpdate((prev) => !prev);
  }, [setSuccessUpdate]);

  return (
    <ModalSendOfBase
      conf={conf}
      button={defaultButton}
      onSubmitAction={onSubmitAction}
      onCloseSuccess={onCloseSuccess}
      withForm={withForm}
      submitLabel={submitLabel}
      loadingLabel={loadingLabel}
      successMessage={successMessage}
      defaultValues={defaultValues}
    >
      {children}
    </ModalSendOfBase>
  );
};

export default ModalSendOfEmail;

